var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "card",
    {
      staticClass: "wp-10 fs-3 p-4 mb-6 subscription-summary",
      attrs: { background: "warning-05", borderColor: "transparent" }
    },
    [
      _c(
        "div",
        {
          staticClass: "flex-row jc-space",
          class: { "mb-3 pb-3 bb-1-gray-40": _vm.isRenew && _vm.isSales }
        },
        [
          _c("div", [
            _c("h2", { staticClass: "bold m-0 mb-3" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Abonnement en cours")))
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "fs-3 mb-3 flex-row flex-bottom" },
              [
                _c("SaasIcon", {
                  staticClass: "gray-100",
                  attrs: {
                    icon: "SvgLogoSellsyCloud",
                    width: "23",
                    height: "17"
                  }
                }),
                _vm._v(" "),
                _vm.isLatestPricingVersion
                  ? _c("span", { staticClass: "capitalize ml-1" }, [
                      _vm._v("Sellsy " + _vm._s(_vm.previousCurrentPlanLabel))
                    ])
                  : _c("span", { staticClass: "capitalize ml-1" }, [
                      _vm._v("Pricing V" + _vm._s(_vm.previousPricingVersion))
                    ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.isLatestPricingVersion
              ? _c(
                  "ul",
                  { staticClass: "my-0" },
                  [
                    _vm._l(_vm.previousProductsWithLicences, function(
                      product,
                      index
                    ) {
                      return _c(
                        "li",
                        {
                          key: product.code,
                          staticClass: "flex-row",
                          class: {
                            "mb-2":
                              index !==
                              _vm.previousProductsWithLicences.length - 1
                          }
                        },
                        [
                          _c("div", [
                            _c("p", { staticClass: "mb-1 mt-0 fs-3" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$l10n.n__(
                                      "%(total)s licence %(productsName)s",
                                      "%(total)s licences %(productsName)s",
                                      _vm.previousProducts[product.id].quantity,
                                      {
                                        total:
                                          _vm.previousProducts[product.id]
                                            .quantity,
                                        productsName: product.title
                                      }
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.previousFreeLicencesByProduct(product.id)
                              ? _c("span", { staticClass: "fs-2" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$l10n.n__(
                                        "Dont %s offerte",
                                        "Dont %s offertes",
                                        _vm.previousFreeLicencesByProduct(
                                          product.id
                                        ),
                                        _vm.previousFreeLicencesByProduct(
                                          product.id
                                        )
                                      )
                                    )
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.previousPacksWithLicences, function(
                      product,
                      index
                    ) {
                      return _c(
                        "li",
                        {
                          key: product.code,
                          staticClass: "flex-row",
                          class: {
                            "mb-2":
                              index !==
                              _vm.previousPacksWithLicences.length - 1,
                            "mt-2": index === 0
                          }
                        },
                        [
                          _c("div", [
                            _c("p", { staticClass: "mb-0 mt-0 fs-3" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$l10n.__("Module %(productsName)s", {
                                      productsName: !!product.groups.length
                                        ? product.printableName
                                        : product.title
                                    })
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm.previousPricingVersion === 3
              ? _c("ul", { staticClass: "my-0" }, [
                  _vm.previousSubcribedProducts.pack_crm
                    ? _c("li", { staticClass: "mb-2 flex-row" }, [
                        _c("div", [
                          _c("p", { staticClass: "m-0 fs-3 lh-20" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$l10n.n__(
                                    "%(total)d utilisateur %(productsName)s",
                                    "%(total)d utilisateurs %(productsName)s",
                                    4,
                                    {
                                      total:
                                        _vm.previousSubcribedProducts.pack_crm
                                          .customerLicense.quantitySubscribed,
                                      productsName:
                                        _vm.previousSubcribedProducts.pack_crm
                                          .title
                                    }
                                  )
                                ) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          !!_vm.previousSubcribedProducts.pack_crm.productPlan
                            .customPricing &&
                          _vm.previousSubcribedProducts.pack_crm.productPlan
                            .customPricing[0].unit_amount === 0
                            ? _c("span", { staticClass: "fs-2" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$l10n.n__(
                                        "Dont %s offerte",
                                        "Dont %s offertes",
                                        _vm.previousSubcribedProducts.pack_crm
                                          .productPlan.customPricing[0].up_to,
                                        _vm.previousSubcribedProducts.pack_crm
                                          .productPlan.customPricing[0].up_to
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.previousSubcribedProducts.pack_invoicing
                    ? _c("li", { staticClass: "mb-2 flex-row" }, [
                        _c("div", [
                          _c("p", { staticClass: "m-0 fs-3 lh-20" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$l10n.__("Module")) +
                                "\n                            " +
                                _vm._s(
                                  _vm.previousSubcribedProducts.pack_invoicing
                                    .title
                                ) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          !!_vm.previousSubcribedProducts.pack_invoicing
                            .productPlan.customPricing &&
                          _vm.previousSubcribedProducts.pack_invoicing
                            .productPlan.customPricing[0].unit_amount === 0
                            ? _c("span", { staticClass: "fs-2" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$l10n.__("Offert")) +
                                    "\n                        "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.previousSubcribedProducts.pack_management
                    ? _c("li", { staticClass: "mb-2 flex-row" }, [
                        _c("div", [
                          _c("p", { staticClass: "m-0 fs-3 lh-20" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$l10n.__("Module")) +
                                "\n                            " +
                                _vm._s(
                                  _vm.previousSubcribedProducts.pack_management
                                    .title
                                ) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          !!_vm.previousSubcribedProducts.pack_management
                            .productPlan.customPricing &&
                          _vm.previousSubcribedProducts.pack_management
                            .productPlan.customPricing[0].unit_amount === 0
                            ? _c("span", { staticClass: "fs-2" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$l10n.__("Offert")) +
                                    "\n                        "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.previousSubcribedProducts.pack_stock
                    ? _c("li", { staticClass: "mb-2 flex-row" }, [
                        _c("div", [
                          _c("p", { staticClass: "m-0 fs-3 lh-20" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$l10n.__("Module")) +
                                "\n                            " +
                                _vm._s(
                                  _vm.previousSubcribedProducts.pack_stock.title
                                ) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          !!_vm.previousSubcribedProducts.pack_stock.productPlan
                            .customPricing &&
                          _vm.previousSubcribedProducts.pack_stock.productPlan
                            .customPricing[0].unit_amount === 0
                            ? _c("span", { staticClass: "fs-2" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$l10n.__("Offert")) +
                                    "\n                        "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.previousSubcribedProducts.pack_support
                    ? _c("li", { staticClass: "mb-2 flex-row" }, [
                        _c("div", [
                          _c("p", { staticClass: "m-0 fs-3 lh-20" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$l10n.__("Module")) +
                                "\n                            " +
                                _vm._s(
                                  _vm.previousSubcribedProducts.pack_support
                                    .title
                                ) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          !!_vm.previousSubcribedProducts.pack_support
                            .productPlan.customPricing &&
                          _vm.previousSubcribedProducts.pack_support.productPlan
                            .customPricing[0].unit_amount === 0
                            ? _c("span", { staticClass: "fs-2" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$l10n.__("Offert")) +
                                    "\n                        "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                ])
              : _c("p", { staticClass: "gray-80" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__("Détails de l'abonnement indisponibles")
                      ) +
                      "\n            "
                  )
                ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "aright" }, [
            _c("div", { staticClass: "flex-row flex-right" }, [
              _vm.isSales || _vm.isPreviouslyYearly
                ? _c("div", { staticClass: "fs-5 bold amount" }, [
                    _c("span", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$filters.numberFormatToFloatWithOptions(
                              _vm.previousCart.total.yearly
                                .total_amount_tax_included,
                              _vm.numformat
                            )
                          ) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fs-4 ml-1" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.numformat.currencysymbol) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fs-3 mt-1" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$l10n.__("/an")) +
                          "\n                    "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isSales || _vm.isPreviouslyMonthly
                ? _c("div", { staticClass: "fs-5 bold ml-4 amount" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.numberFormatToFloatWithOptions(
                            _vm.previousCart.total.monthly
                              .total_amount_tax_included,
                            _vm.numformat
                          )
                        ) + "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fs-4 ml-1" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.numformat.currencysymbol) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fs-3" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$l10n.__("/mois")) +
                          "\n                    "
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.labelPlan))]),
              _vm._v(" "),
              _c("p", { staticClass: "fs-2 mt-1 mb-0" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Renouvellement le %s",
                        _vm.$filters.dateFormatter(
                          _vm.previousCart.serviceEndDate,
                          "SLASHED_DATE",
                          false
                        )
                      )
                    ) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _vm.isSales
                ? _c("p", { staticClass: "fs-2 mt-0" }, [
                    _vm._v(_vm._s(_vm.leftDurationSubscription))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _c("span", [_vm._v(_vm._s(_vm.paymentMethodLabel))])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.isRenew && _vm.isSales
        ? _c("div", [
            _c("h3", { staticClass: "bold m-0 mb-2 lh-24" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Utilisation de l’abonnement en cours")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "m-0 lh-20 fs-3 regular" }, [
              _vm._v(_vm._s(_vm.subscriptionUseLabel("nbActiveUsers")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-level" },
              [
                _vm.subscriptionUses.nbPermissionProfiles !== null
                  ? [
                      _c("p", { staticClass: "fs-2 m-0 regular" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.subscriptionUseLabel("nbPermissionProfiles")
                            ) +
                            "\n                "
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.subscriptionUses.nbPipelines !== null
                  ? [
                      _c("span", { staticClass: "px-2" }, [_vm._v("|")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "fs-2 m-0 regular" }, [
                        _vm._v(_vm._s(_vm.subscriptionUseLabel("nbPipelines")))
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.subscriptionUses.nbCustomFields !== null
                  ? [
                      _c("span", { staticClass: "px-2" }, [_vm._v("|")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "fs-2 m-0 regular" }, [
                        _vm._v(
                          _vm._s(_vm.subscriptionUseLabel("nbCustomFields"))
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.subscriptionUses.nbDunnings !== null
                  ? [
                      _c("span", { staticClass: "px-2" }, [_vm._v("|")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "fs-2 m-0 regular" }, [
                        _vm._v(_vm._s(_vm.subscriptionUseLabel("nbDunnings")))
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }